import { gql } from "@apollo/client";

export const CREATE_VEHICLE_SERVICE = gql`
  mutation createVehicleService($vehicleService: CreateVehicleServiceInput!) {
    createVehicleService(vehicleService: $vehicleService) {
      serviceType
      scheduleType{
        byMonth,
        byMileage
      }
      serviceProviderId
      serviceProviderName
      serviceProviderAddress{
        street
        city
        fullAddress
        state
        country
        zipcode
      }
      serviceAnniversaryByMileage
      odometerReading
      description
      totalExpenses
      documents {
        title
        documentName
        documentType
        documentUrl
        expiryDate
        createdAt
      }
      status
      notes{
        description,
        createdBy {
          id
          firstName
          lastName
        }
        createdDate
      }
      damages{
        id
        referenceNumber
        circumstance
        bookingRef
        reportDate
        status
      }
      vehicleId
      appointmentDate
      startDate
      endDate
      completionDate
      vehicleEvent{
        id
        vehicle
        eventStartDateTime
        eventEndDateTime
        odometerReadingAtStart
        odometerReadingAtEnd
        odometerReadingAtStartImg
        odometerReadingAtEndImg
        isBillable
        usedBy
      }
    }
  }
`;
